/** Brand red used by the mobile app header and primary buttons. */
export const BRAND = "#C0282C";

export const BOMOF_LABEL: Record<string, string> = {
  "00": "Both Parents",
  "11": "Only Father",
  "12": "Only Mother",
};

export const ADDITION_DELETION_LABEL: Record<string, string> = {
  "0": "Addition",
  "1": "Deletion",
};

export const DOC_TYPE = {
  FATHER_PHOTO: "01",
  MOTHER_PHOTO: "02",
  FATHER_ID: "11",
  MOTHER_ID: "12",
  FATHER_RESIDENCY: "21",
  MOTHER_RESIDENCY: "22",
  FATHER_INCOME: "31",
  MOTHER_INCOME: "32",
  NOT_AVAILING_MEDICAL_FACILITY: "40",
  SIBLING_NOC_CERTIFICATE_FROM_ORG: "50",
  SPOUSE_NOC_CERTIFICATE: "55",
  WIDOW_PENSION_ORDER: "62",
  SPOUSE_DMRC_UNDERTAKING: "65",
  SIBLING_DMRC_UNDERTAKING: "66",
  OTHER: "70",
  DECEASED_FATHER_DEATH_CERT: "81",
  DECEASED_MOTHER_DEATH_CERT: "82",
} as const;

export const DOC_TYPE_DEATH_CERTIFICATE = "DEATH_CERTIFICATE";

export const DOC_TYPE_LABEL: Record<string, string> = {
  "01": "Father Photo",
  "02": "Mother Photo",
  "11": "ID proof for Father",
  "12": "ID proof for Mother",
  "21": "Residency Proof for Father",
  "22": "Residency Proof for Mother",
  "31": "Income Proof for Father",
  "32": "Income Proof for Mother",
  "40": "Not Availing Medical Facility if Retired from govt./PSU etc.",
  "44": "Medical Dependency Card",
  "50": "NOC from Sibling working in Govt./PSU etc. organization",
  "55": "NOC from Spouse working in Govt./PSU etc. organization",
  "62": "Widow pension pay order in case of widow mother and ITR",
  "65": "Undertaking from spouse working in DMRC",
  "66": "Undertaking from sibling working in DMRC",
  "70": "Any Affidavit(if required)/other documents",
  "81": "Death Certificate (Father)",
  "82": "Death Certificate (Mother)",
};

export const STATUS_UI: Record<string, { color: string; label: string }> = {
  N: { color: "#2563EB", label: "New" },
  T: { color: "#EA580C", label: "To be approved" },
  P: { color: "#F59E0B", label: "Partially Approved" },
  A: { color: "#16A34A", label: "Approved" },
  R: { color: "#DC2626", label: "Rejected" },
  D: { color: "#7C3AED", label: "Processing Complete" },
  X: { color: "#64748B", label: "Deleted" },
  B: { color: "#0891B2", label: "To Be Processed" },
  C: { color: "#334155", label: "Closed" },
  K: { color: "#991B1B", label: "Cancelled" },
  S: { color: "#059669", label: "Settled" },
  I: { color: "#16A34A", label: "Completed" },
  DEFAULT: { color: "#64748B", label: "Insapprocess" },
  PENDING: { color: "#F59E0B", label: "Pending" },
  DRAFT: { color: "#64748B", label: "Draft" },
  APPROVED: { color: "#16A34A", label: "Approved" },
  REJECTED: { color: "#DC2626", label: "Rejected" },
  SAVED: { color: "#2563EB", label: "Saved" },
  INFORMED: { color: "#0891B2", label: "Informed" },
  TO_BE_APPROVED: { color: "#EA580C", label: "To be approved" },
  PARTIALLY_APPROVED: { color: "#F59E0B", label: "Partially Approved" },
  TO_BE_PROCESSED: { color: "#0891B2", label: "To Be Processed" },
  PROCESSING_COMPLETE: { color: "#7C3AED", label: "Processing Complete" },
  APPROVE: { color: "#16A34A", label: "Approved" },
  REJECT: { color: "#DC2626", label: "Rejected" },
  INPROCESS: { color: "#EA580C", label: "To be approved" },
  IN_PROCESS: { color: "#EA580C", label: "To be approved" },
};

export const PARENTS_INSTRUCTIONS = `Check List for applying for Inclusion of dependent parent/s
माता-पिता को आश्रित सूची में शामिल करने के लिए आवेदन की चेकलिस्ट

List of required Documents to be uploaded / अपलोड किए जाने वाले आवश्यक दस्तावेज़ों की सूची:

I] Photograph / फोटो
-- Passport size photo of Parents
-- माता-पिता का पासपोर्ट आकार का फोटो

II] ID Proof for Parents / माता-पिता का पहचान पत्र प्रमाण
1. Aadhar Card / आधार कार्ड
2. Voter ID / मतदाता पहचान पत्र (वोटर आईडी)
3. Driving License / ड्राइविंग लाइसेंस
4. Pan Card / पैन कार्ड
5. Passport / पासपोर्ट
Any of the above / उपर्युक्त में से कोई एक

III] Residence Proof / निवास प्रमाणपत्र
1. Aadhar Card / आधार कार्ड
2. Voter ID / मतदाता पहचान पत्र
3. Driving License / ड्राइविंग लाइसेंस
4. Passport / पासपोर्ट
5. Domicile Certificate / निवास प्रमाणपत्र
Any of the above / उपर्युक्त में से कोई एक

IV] Income Proof / आय प्रमाणपत्र
1. Pension Pay Orders of parent/s with pension A/c Pass-book, in case of retired Govt. / State Govt/Semi Govt/PSU employee/s & ITR/Income Certificate
सेवानिवृत्त (सरकारी/राज्य सरकार/अर्ध-सरकारी/ पीएसयू) कर्मचारी के मामले में, माता-पिता का पेंशन आदेश के साथ पेंशन खाता पासबुक एवं उनका आयकर रिटर्न/आय प्रमाणपत्र।
2. In case, employee's parent/s have own business, non-regular income, the employee will submit Income Tax Return or an Income Certificate issued by local authorities (BDO/SDM).
यदि कर्मचारी के माता-पिता का अपना व्यवसाय, गैर-नियमित आय है तो कर्मचारी उनका आयकर रिटर्न या स्थानीय अधिकारियों (बीडीओ/एसडीएम) द्वारा जारी आय प्रमाणपत्र प्रस्तुत करेगा।
3. If, parent/s working in non-Govt. organization, the employee will submit their latest Income Tax Return/Income Certificate.
यदि माता-पिता गैर-सरकारी संगठन में कार्यरत हैं तो कर्मचारी अपना नवीनतम आयकर रिटर्न/ आय प्रमाणपत्र जमा करेगा।
4. If, parents hold BPL Card/Old-age pension certificate, a copy of the same may be submitted and ITR/income certificate.
यदि माता-पिता के पास बीपीएल कार्ड/वृद्धावस्था पेंशन प्रमाणपत्र है, तो उसकी एक प्रति और आयकर रिटर्न/आय प्रमाणपत्र जमा किया जा सकता है।

V] For Parents who have retired from Govt./PSU/Semi Govt./Local bodies
उन माता-पिता के लिए जो सरकारी/पीएसयू/अर्ध-सरकारी/स्थानीय निकायों से सेवानिवृत्त हुए हैं
1. He/she shall submit certificate from his/her employer that Post Retirement Medical Benefits are not available.
कर्मचारी अपने नियोक्ता से इस आशय का प्रमाणपत्र प्रस्तुत करेगा कि सेवानिवृत्ति के बाद चिकित्सा लाभ उपलब्ध नहीं हैं।
2. Latest ITR/Income Certificate.
नवीनतम आयकर रिटर्न/ आय प्रमाणपत्र।

VI] If sibling is/are working in Govt./PSU/Semi Govt./Local bodies etc.
यदि भाई-बहन सरकारी/ पीएसयू/अर्ध-सरकारी/स्थानीय निकायों आदि में कार्यरत हैं
-- Certificate for not availing for medical/LTC facilities of parents on letterhead of the organization is required.
-- भाई/बहन के संगठन के लेटरहेड पर माता-पिता की चिकित्सा/ एलटीसी सुविधाओं के लिए कोई दावा नहीं करने का प्रमाणपत्र।

VII] For Widow Mother / विधवा माँ के लिए
-- Widow pension pay order and ITR/Income Certificate.
-- विधवा पेंशन भुगतान आदेश और आयकर रिटर्न/ आय प्रमाणपत्र।`;

export const MANDATORY_DOCUMENTS = `1. ID proof- Aadhaar card Voter ID card/Driving License/Passport etc

2. Residence proof- Aadhaar card Voter ID card/Driving License/Passport/Ration card/etc.

3. Income proof (any one):

a. Pension Pay Orders of parent/s with pension A/c Pass-book in case of retired Govt./State Govt/Semi Govt/PSU employees

b. In case employee's parents have own business/non-regular income, the employee will submit Income Tax Return or an Income Certificate issued by local authorities (BDO/SDM)

c. If parent/s working in non-Govt. organization, the employee will submit their latest Income Tax Return

d. If parents hold BPL Card/Old-age pension certificate, a copy of the same may be submitted

4. If parent is retired from Govt/PSU/Semi Govt./Local bodies, submit certificate that Post Retirement Medical Benefits are not available

5. If sibling(s) working in Govt/PSU/Semi Govt./Local bodies, certificate for no claim for medical/LTC facilities by parents is required

6. Widow pension pay order in case of widow mother and ITR

7. Any other document (if required)

Note: If income of parent is NIL, enter value '1' in Monthly income field`;

export const SPOUSE_CHILDREN_INSTRUCTIONS = `List of required Documents to be uploaded / अपलोड किए जाने वाले आवश्यक दस्तावेज़ों की सूची:

I] Photograph of child/spouse
बच्चे/ पति/पत्नी का फोटो
-- Passport size photo of child/spouse
-- बच्चे/ पति/पत्नी का पासपोर्ट आकार का फोटो

II] Marriage proof mentioning name of spouse and date of marriage
विवाह के प्रमाण में पति/पत्नी का नाम और विवाह की तारीख का उल्लेख हो
-- Marriage registration form/marriage card
-- विवाह पंजीकरण फॉर्म/ विवाह कार्ड

III] Child/spouse date of birth proof
बच्चे/ पति/पत्नी की जन्मतिथि का प्रमाण
-- birth certificate / जन्म प्रमाणपत्र
-- aadhar / आधार
-- 10th passing certificate / 10वीं कक्षा का प्रमाणपत्र
उपर्युक्त में से कोई एक

IV] NOC from working spouse (if dependency required)
कामकाजी पति/पत्नी से एनओसी (यदि निर्भरता आवश्यक हो)
-- NOC from spouse department for LTC & medical facilities for the child/spouse
-- बच्चे/ पति/पत्नी के लिए एलटीसी और चिकित्सा सुविधाओं के लिए पति/पत्नी के विभाग से एनओसी`;

export const DEPENDENT_DOCUMENTS_NOTE = `- In case of spouse, Marriage proof/Certificate, Govt. authorized Identity Proof of spouse/D.O.B. proof
- In case spouse is working, NOC or Cessation certificate
- In case of child, Birth Certificate/Govt. Authorized Identity Proof/ D.O. B. Proof.
- Any affidavit (if required)`;

export const DECLARATION_TEXT =
  "I certify that my parents are not availing medical facility from any other source. If at any stage the above particulars are found false/wrong, DMRC may take action against me under DMRC conduct rules.";

export const FALLBACK_ADDITION_OF = [
  { id: "00", label: "Both Parents" },
  { id: "11", label: "Only Father" },
  { id: "12", label: "Only Mother" },
];

export const FALLBACK_RELATIONSHIP = [
  { id: "Spouse", label: "Spouse" },
  { id: "Child", label: "Child" },
];
export const FALLBACK_GENDER = [
  { id: "Male", label: "Male" },
  { id: "Female", label: "Female" },
];
export const FALLBACK_NATIONALITY = [{ id: "Indian", label: "Indian" }];
export const FALLBACK_DEPENDENCY = [
  { id: "", label: "Not Dependent" },
  { id: "M", label: "Medical and SWF, Only" },
  { id: "L", label: "LTC and SWF, Only" },
  { id: "S", label: "SWF only" },
  { id: "X", label: "Complete Dependency (Medical+ LTC+ SWF)" },
  { id: "R", label: "Only Medical (For retired and Spouse of Deceased Employee)" },
];
export const FALLBACK_EMPLOYMENT = [
  { id: "Working with DMRC", label: "Working with DMRC" },
  { id: "working with Central/State Govt", label: "working with Central/State Govt" },
  { id: "working with CPSE/PSU's/Local Bodies", label: "working with CPSE/PSU's/Local Bodies" },
  { id: "Self-employed", label: "Self-employed" },
  { id: "Not employed", label: "Not employed" },
  { id: "Retired from Govt./PSU/Other", label: "Retired from Govt./PSU/Other" },
  { id: "Others", label: "Others" },
];
export const FALLBACK_ROOF = [
  { id: "Yes", label: "Yes" },
  { id: "No", label: "No" },
];
export const FALLBACK_REASON_ROOF = [
  { id: "Family retention", label: "Family retention" },
  { id: "Staying in hostel", label: "Staying in hostel" },
  { id: "Others", label: "Others" },
  { id: "Hardship/Difficult/Remote location", label: "Hardship/Difficult/Remote location" },
];
export const FALLBACK_MARITAL = [
  { id: "Married", label: "Married" },
  { id: "UnMarried", label: "UnMarried" },
];
